<template>
    <cadastro-simples-form
        endpoint="categoria-disciplina"
        rota-base="/admin/categoria-disciplina"
        titulo-singular="Categoria de Disciplina"
        :campos-extras='[]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
